const COLOR_MAP = {
  "text-white": { gradient: "from-zinc-400/50", label: "text-zinc-400/60", glow: "rgba(161,161,170,0.06)", border: "border-zinc-700/30" },
  "text-green-400": { gradient: "from-emerald-500/50", label: "text-emerald-400/60", glow: "rgba(52,211,153,0.06)", border: "border-emerald-500/10" },
  "text-emerald-400": { gradient: "from-emerald-500/50", label: "text-emerald-400/60", glow: "rgba(52,211,153,0.06)", border: "border-emerald-500/10" },
  "text-amber-400": { gradient: "from-amber-500/50", label: "text-amber-400/60", glow: "rgba(245,158,11,0.06)", border: "border-amber-500/10" },
  "text-cyan-400": { gradient: "from-cyan-500/50", label: "text-cyan-400/60", glow: "rgba(34,211,238,0.06)", border: "border-cyan-500/10" },
  "text-purple-400": { gradient: "from-purple-500/50", label: "text-purple-400/60", glow: "rgba(168,85,247,0.06)", border: "border-purple-500/10" },
  "text-blue-400": { gradient: "from-blue-500/50", label: "text-blue-400/60", glow: "rgba(96,165,250,0.06)", border: "border-blue-500/10" },
};

export default function StatCard({ icon: Icon, label, value, color }) {
  const colors = COLOR_MAP[color] || { gradient: "from-cyan-500/50", label: "text-zinc-500", glow: "rgba(34,211,238,0.06)", border: "border-zinc-700/30" };

  return (
    <div
      className={`group/stat bg-zinc-900/40 backdrop-blur-sm border border-zinc-800/50 ${colors.border} p-3 sm:p-4 rounded-xl relative overflow-hidden hover:border-zinc-700/50 transition-colors duration-300 hover:-translate-y-0.5`}
      style={{ boxShadow: `0 0 20px ${colors.glow}` }}
    >
      <div className={`absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r ${colors.gradient} to-transparent opacity-80`} />
      <div className="absolute inset-0 bg-gradient-to-br from-white/[0.02] to-transparent opacity-0 group-hover/stat:opacity-100 transition-opacity duration-300" />
      <div className={`flex items-center gap-1.5 ${colors.label} mb-1.5 relative`}>
        <Icon className="w-3.5 h-3.5" />
        <span className="text-[10px] sm:text-[11px] uppercase tracking-wider font-medium">{label}</span>
      </div>
      <p className={`text-lg sm:text-2xl font-mono font-bold ${color} relative tracking-tight`}>{value}</p>
    </div>
  );
}
